import { routeNames, routePaths } from '@/router/router-constants'
import type { RouteRecordRaw } from 'vue-router'

export const deadlineRoutes: RouteRecordRaw[] = [
  {
    path: routePaths.deadlines,
    name: routeNames.deadlines,
    component: () => import('@/pages/deadlines/DeadlinesView.vue'),
    meta: {
      permission: 'deadlines.read.assigned',
      icon: 'material-symbols-outlined',
      iconText: 'calendar_clock',
      labelKey: 'deadlines',
    },
  },
  {
    path: routePaths.deadlineBadges,
    name: routeNames.deadlineBadges,
    component: () => import('@/pages/deadlines/DeadlineBadgesView.vue'),
    meta: {
      permission: 'deadline-badges.write.all',
      icon: 'material-symbols-outlined',
      iconText: 'badge',
      labelKey: 'deadlineBadges',
    },
  },
]
